export const checkOnline = {
  data () {
    return {
      onLine: navigator.onLine,
      showBackOnline: false
    }
  },
  methods: {
    updateOnlineStatus (e) {
      const { type } = e
      this.onLine = type === 'online'
    }
  },
  watch: {
    onLine (v) {
      if (!v) {
        this.popUpNetwork = true
        // 
        // this.showBackOnline = true
        // setTimeout(() => { this.showBackOnline = false }, 1000)
      } else {
        this.popUpNetwork = false

      }
    }
  },
  mounted () {
    window.addEventListener('online',  this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
  },
  beforeDestroy () {
    window.removeEventListener('online',  this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
  }
}